import { gql } from "@apollo/client";

export const GetAllPointRedemptionUsages = gql`
  query GetAllPointRedemptionUsages($broker_id: ID!) {
    getAllPointRedemptionUsages(broker_id: $broker_id) {
      id
      points_redemptions_id
      status
      prize
      voucher
      created_at
      updated_at
      redeemed_by {
        id
        assoc_first_name
        assoc_last_name
        assoc_email
        assoc_primary_phonenumber
        position
      }
    }
  }
`;

export const GET_POINT_REDEMPTION_USAGE = gql`
  query GetPointRedemptionUsage($redemption_id: ID!) {
    getPointRedemptionUsage(redemption_id: $redemption_id) {
      id
      points_redemptions_id
      status
      prize
      voucher
      created_at
      updated_at
      redeemed_by {
        id
        assoc_first_name
        assoc_last_name
        assoc_email
        assoc_primary_phonenumber
        position
      }
    }
  }
`;
